import { ImagePost, Video } from '../views/Campaign/types';

export interface TwitterSocialPost {
  campaign_influencer_id: number;
  date: string;
  emv: number;
  favorites: number;
  fetched_at: string;
  followers_count: number;
  following_count: number;
  full_name: string;
  impression_count: number;
  language: string;
  media_types: ['video'];
  media_url: string;
  permalink: string;
  replies: number;
  resource: 'twitter';
  retweets: number;
  text: string;
  tweet_id: string;
  twitter_user_id: string;
  username: string;
  duration?: number;
}

export interface TwitterSocialPostImage {
  campaign_influencer_id: number;
  date: string;
  emv: number;
  favorites: number;
  fetched_at: string;
  followers_count: number;
  following_count: number;
  full_name: string;
  impression_count: number;
  language: string;
  media_types: ['photo'];
  media_url: string;
  permalink: string;
  replies: number;
  resource: 'twitter';
  retweets: number;
  text: string;
  tweet_id: string;
  twitter_user_id: string;
  username: string;
  duration?: number;
}

export const twitterVideoToCampaignVideo = (
  twitterPost: TwitterSocialPost,
  campaign_id: number
): Video => {
  return {
    published_at: twitterPost.date,
    id: twitterPost.tweet_id,
    video_type: twitterPost.media_types[0] || 'video',
    video_title: twitterPost.text,
    link: twitterPost.permalink,
    campaign_influencer_ids: [twitterPost.campaign_influencer_id],
    avg_cc_viewers: null,
    max_cc_viewers: null,
    total_views: null,
    computed_total_views: null,
    emv: twitterPost.emv,
    comments_count: twitterPost.replies,
    engagement_rate: null,
    duration: twitterPost.duration,
    sentiment: null,
    video_segments: null,
    time_zone: null,
    followers_gained: null,
    resource: 'twitter',
    thumbnails: {
      default: {
        url: twitterPost.media_url,
      },
    },
    influencer_id: parseInt(twitterPost.twitter_user_id),
    campaign_id: campaign_id,
    language: twitterPost.language,
    video_followers: null,
    minutes_watched_by_audience: null,
    streamer_id: null,
    external_id: String(twitterPost.tweet_id),
    live_chat_count: null,
    is_live: false,
    recording_link: null,
    likes_count: null,
  };
};

export const twitterImageToCampaignImagePosts = (
  twitterPost: TwitterSocialPostImage,
  campaign_id: number
): ImagePost => {
  return {
    published_at: twitterPost.date,
    id: twitterPost.tweet_id,
    image_title: twitterPost.text,
    link: twitterPost.permalink,
    campaign_influencer_ids: [twitterPost.campaign_influencer_id],
    emv: twitterPost.emv,
    comments_count: twitterPost.replies,
    engagement_rate: null,
    duration: twitterPost.duration,
    sentiment: null,
    time_zone: null,
    followers_gained: null,
    resource: 'twitter',
    thumbnails: {
      default: {
        url: twitterPost.media_url,
      },
    },
    influencer_id: parseInt(twitterPost.twitter_user_id),
    campaign_id: campaign_id,
    language: twitterPost.language,
    video_followers: null,
    streamer_id: null,
    external_id: String(twitterPost.tweet_id),
    likes_count: null,
  };
};
